export const uploadTransactionSelector = (state) => state.fraudUploadTransactionSlice;

